"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _Deprecated = _interopRequireDefault(require("../decorators/Deprecated"));

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UIAbstractDateInput = _interopRequireDefault(require("./abstract/UIAbstractDateInput"));

var UIInlineDateInput = _react.default.createClass({
  displayName: "UIInlineDateInput",
  propTypes: (0, _extends2.default)({}, (0, _omit.default)(_UIAbstractDateInput.default.propTypes, ['children'])),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UIAbstractDateInput.default.defaultProps);
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = (0, _objectWithoutProperties2.default)(_this$props, ["className"]);
    return _react.default.createElement(_UIAbstractDateInput.default, (0, _extends2.default)({}, props, {
      className: "uiInlineDateInput"
    }), function (dateProps) {
      return _react.default.createElement("input", (0, _extends2.default)({}, (0, _omit.default)(dateProps, ['hideFocusOutline', 'isPickerOpen']), {
        className: (0, _classNames.default)('uiUnstyledInput', 'uiInlineDateInputInput', className)
      }));
    });
  }
});

var _default = (0, _Deprecated.default)('Please use the new, jQuery-free `UIDateInput` instead.', 'https://git.hubteam.com/HubSpot/UIComponents/issues/7490')((0, _Controllable.default)(UIInlineDateInput));

exports.default = _default;
module.exports = exports.default;